import { MultiCheckboxFilterOption } from '../../../FilterResultsManager/options/types';
import { MultiSelectCheckbox } from '../../../FilterResultsManager/components';

export const config: MultiCheckboxFilterOption = {
  id: 'jaxGeneDrugEvidence.filters.approvalStatus',
  title: {
    id: 'jaxGeneDrugEvidence.filters.approvalStatus',
    defaultMessage: 'Approval Status',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'approval_status',
    checkboxOptions: [
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.caseReportsCaseSeries',
        searchValue: 'Case Reports/Case Series',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.caseReportsCaseSeries',
          defaultMessage: 'Case Reports/Case Series',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.clinicalStudy',
        searchValue: 'Clinical Study',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.clinicalStudy',
          defaultMessage: 'Clinical Study',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.clinicalStudyCohort',
        searchValue: 'Clinical Study - Cohort',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.clinicalStudyCohort',
          defaultMessage: 'Clinical Study - Cohort',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.clinicalStudyMetaAnalysis',
        searchValue: 'Clinical Study - Meta-analysis',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.clinicalStudyMetaAnalysis',
          defaultMessage: 'Clinical Study - Meta-analysis',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.expandedAccess',
        searchValue: 'Expanded Access',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.expandedAccess',
          defaultMessage: 'Expanded Access',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.FDAApproved',
        searchValue: 'FDA Approved',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.FDAApproved',
          defaultMessage: 'FDA Approved',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.FDAApprovedHasCompanionDiagnostic',
        searchValue: 'FDA Approved - Has Companion Diagnostic',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.FDAApprovedOnCompanionDiagnostic',
          defaultMessage: 'FDA Approved - Has Companion Diagnostic',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.FDAApprovedOnCompanionDiagnostic',
        searchValue: 'FDA Approved - On Companion Diagnostic',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.FDAApprovedOnCompanionDiagnostic',
          defaultMessage: 'FDA Approved - On Companion Diagnostic',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.FDAContraindicated',
        searchValue: 'FDA Contraindicated',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.FDAContraindicated',
          defaultMessage: 'FDA Contraindicated',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.guideline',
        searchValue: 'Guideline',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.guideline',
          defaultMessage: 'Guideline',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.phase0',
        searchValue: 'Phase 0',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.phase0',
          defaultMessage: 'Phase 0',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.phaseI',
        searchValue: 'Phase I',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.phaseI',
          defaultMessage: 'Phase I',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.phaseIBII',
        searchValue: 'Phase IB/II',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.phaseIBII',
          defaultMessage: 'Phase IB/II',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.phaseII',
        searchValue: 'Phase II',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.phaseII',
          defaultMessage: 'Phase II',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.phaseIII',
        searchValue: 'Phase III',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.phaseIII',
          defaultMessage: 'Phase III',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinicalPdx',
        searchValue: 'Preclinical - Pdx',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinicalPdx',
          defaultMessage: 'Preclinical - Pdx',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinical',
        searchValue: 'Preclinical',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinical',
          defaultMessage: 'Preclinical',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinicalCellCulture',
        searchValue: 'Preclinical - Cell culture',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinicalCellCulture',
          defaultMessage: 'Preclinical - Cell culture',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinicalCellLineXenograft',
        searchValue: 'Preclinical - Cell line xenograft',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinicalCellLineXenograft',
          defaultMessage: 'Preclinical - Cell line xenograft',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinicalPatientCellCulture',
        searchValue: 'Preclinical - Patient cell culture',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinicalPatientCellCulture',
          defaultMessage: 'Preclinical - Patient cell culture',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinicalPdxCellCulture',
        searchValue: 'Preclinical - Pdx & cell culture',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.approvalStatus.preclinicalPdxCellCulture',
          defaultMessage: 'Preclinical - Pdx & cell culture',
        },
      },
    ],
  },
};
